/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { OrganizationApiConfiguration as __Configuration } from '../organization-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultSkillInfo } from '../models/list-query-result-skill-info';
import { CreateSkillCommand } from '../models/create-skill-command';
import { UpdateSkillCommand } from '../models/update-skill-command';
@Injectable({
  providedIn: 'root',
})
class SkillService extends __BaseService {
  static readonly GetAllPath = '/api/organization/skills';
  static readonly CreateSkillPath = '/api/organization/skills';
  static readonly GetUpdateSkillPath = '/api/organization/skills/{id}/update';
  static readonly UpdateSkillPath = '/api/organization/skills/{id}/update';
  static readonly DeleteSkillPath = '/api/organization/skills/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `SkillService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAllResponse(params: SkillService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultSkillInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/skills`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultSkillInfo>;
      })
    );
  }
  /**
   * @param params The `SkillService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAll(params: SkillService.GetAllParams): __Observable<ListQueryResultSkillInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultSkillInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateSkillResponse(command?: CreateSkillCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/organization/skills`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateSkill(command?: CreateSkillCommand): __Observable<null> {
    return this.CreateSkillResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateSkillResponse(id: string): __Observable<__StrictHttpResponse<UpdateSkillCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/skills/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateSkillCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateSkill(id: string): __Observable<UpdateSkillCommand> {
    return this.GetUpdateSkillResponse(id).pipe(
      __map(_r => _r.body as UpdateSkillCommand)
    );
  }

  /**
   * @param params The `SkillService.UpdateSkillParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateSkillResponse(params: SkillService.UpdateSkillParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/organization/skills/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `SkillService.UpdateSkillParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateSkill(params: SkillService.UpdateSkillParams): __Observable<null> {
    return this.UpdateSkillResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteSkillResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/organization/skills/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteSkill(id: string): __Observable<null> {
    return this.DeleteSkillResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module SkillService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for UpdateSkill
   */
  export interface UpdateSkillParams {
    id: string;
    command?: UpdateSkillCommand;
  }
}

export { SkillService }
